import { render } from "./GoldTabGuide.vue?vue&type=template&id=bc84bd46&scoped=true"
import script from "./GoldTabGuide.vue?vue&type=script&lang=js"
export * from "./GoldTabGuide.vue?vue&type=script&lang=js"

import "./GoldTabGuide.vue?vue&type=style&index=0&id=bc84bd46&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc84bd46"]])

export default __exports__